import { Form, Select, Modal, Switch, Drawer } from 'antd';
import { authFetch } from '../../../../common/request/authFetch';
import { useFetch } from '../../../../hooks/useFetch/useFetch';
import { ColorStar } from '../../../../common/utils/ColorStar';
import { useState } from 'react';
import TableLZM from '../../../components/design/table/TableLZM';
import { customRequest } from '../../../../common/request/customRequest';
import { ButtonLZ } from '../../../components/design/Buttons/ButtonLZ';
import { DrawerPanelTitle, drawerPanelStyles } from '../../common/Drawers/DrawerPanelTitle';

export const EmailProjectDrawer = (props: {
    onFinish: any,
    onClose: any,
    emailProject: any
}) => {

    const [reviewsInfo, setReviewsInfo] = useState(null);
    const [updateData, setUpdateData] = useState(false);

    useFetch(`${process.env.REACT_APP_API}/tech/services/projects/` + props.emailProject.project + '/email/' + props.emailProject.googleEmail, {}, [],    
    (data: any) => {
        setReviewsInfo(data);        
    });

    const syncAndFixGroup = async (project: string, group: string) => {    
        await customRequest(`${process.env.REACT_APP_API}/tech/services/projects/${project}/syncandfixgroup/${group}`, { method: 'POST' });
    }  
        
    const syncAndFixLocation = async (project: string, group: string, locationId: string) => {
        await customRequest(`${process.env.REACT_APP_API}/tech/services/projects/${project}/syncandfixlocation/${group}/${locationId}`, { method: 'POST' });
    }  

    const columns: any = [		
        {
			title: '',
			key: 'sync',			
			align: 'center',
			//sorter: (a: any, b: any) => b.reviewsKPIs?.numberOfReviews - a.reviewsKPIs?.numberOfReviews,
			render: (text: string, record: any) => (
                <>
                    <ButtonLZ size='small' color='yellow' onClick={() => {syncAndFixLocation(record.accountName, record.name, record.locationId);}}>
                        Sync Local 
                    </ButtonLZ>
                </>
				)			
		},
        {
			title: 'Grupo',
			key: 'accountName',			
			align: 'center',
			//sorter: (a: any, b: any) => b.reviewsKPIs?.numberOfReviews - a.reviewsKPIs?.numberOfReviews,
			render: (text: string, record: any) => (
                <>
                    
                    <ButtonLZ size='small' color='yellow' onClick={() => {syncAndFixGroup(record.accountName, record.name);}}>
                        Sync {record.accountName}
                    </ButtonLZ>
                </>
				)			
		},
        {
			title: 'Local',
			key: 'title',			
			align: 'center',
			//sorter: (a: any, b: any) => b.reviewsKPIs?.numberOfReviews - a.reviewsKPIs?.numberOfReviews,
			render: (text: string, record: any) => (
                <>
                    <div>{record.title}</div>
                    <small style={{color:'grey'}}>{record.administrativeArea}, {record.addressLine}</small>
                    <div><a href={record.locationLink} target='blank'>Link</a></div>
                </>
				)			
		},
		{
			title: 'Puntuación',
			key: 'rateAvg',
			dataIndex: 'rateAvg',
			width: '20px',
			align: 'center',
			//sorter: (a: any, b: any) => b.reviewsKPIs?.rateAvg - a.reviewsKPIs?.rateAvg,
			render: (text: string, record: any) => (record.reviewsInfo?.avgStarRating &&
                <>
                    <div><ColorStar
                        style={{ fontSize: '18px' }}
                        value={Math.round(10 * record.reviewsInfo.avgStarRating) / 10}/>
                    </div>
                    <div>{record.reviewsInfo.numberOfReviews} reseñas</div>    					
				</>)			
		}		
    ]

    return (

        <Drawer
            placement="right"
            width={'50%'}
            open={true}            
            onClose={props.onClose}
            {...drawerPanelStyles}
            title={<DrawerPanelTitle title="Locales con reseñas" />}>

            
            {reviewsInfo &&						
							<TableLZM 
								//rowKey='reviewsInfo._id'
								scroll={{ x: true, y: 800 }}						
								columns={columns}
								dataSource={reviewsInfo}
								loading={false}/>
						}	

        </Drawer>
    )
}

